import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import moment from "moment";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import GenericButton from "../../../UI/Button/Button";
import acceptAuthIcon from "../../../../../public/svg/tickAuthorizations.svg";
import rejectAuthIcon from "../../../../../public/svg/rejectAuthorizations.svg";
import { fetchInProcesOrderPDF } from "../../../../services/api/accounts";
import { useSelector } from "react-redux";
import { getCurrentAccount } from "../../../../reducers/selectors";
import pdf from "../../../../../public/svg/downloadPdf.svg";

import style from "./AuthorizationRow.scss";

const AuthorizationRow = ({
  authItem,
  side,
  description,
  ammount,
  operationValue,
  currency,
  idx,
  onAuthorize,
  onReject,
  loading,
  setLoading,
}) => {
  const [order, setOrder] = useState(null);
  const currentAccount = useSelector(getCurrentAccount);

  useEffect(() => {
    if (authItem) {
      if (authItem.process === "Order" && authItem.info) {
        const orderInfo = JSON.parse(authItem.info);
        orderInfo.ammount = 0;

        switch (orderInfo.OrderType.trim()) {
          case "Market":
          case "MarketOnOpen":
          case "MarketOnClose":
            orderInfo.ammountString = "Mercado";
            break;
          case "Limit":
            orderInfo.ammountString = "Limit";
            orderInfo.ammount = orderInfo.OrderPrice;
            break;
          case "Stop":
            orderInfo.ammountString = "Stop";
            orderInfo.ammount = orderInfo.OrderStopPrice;
            break;
          case "StopLimit":
            orderInfo.ammountString = "Stop Limit";
            orderInfo.ammount = orderInfo.OrderStopPrice;
            break;
          default:
            break;
        }

        setOrder(orderInfo);
      }
    }
  }, [authItem]);

  const handleDownload = (order) => {
    setLoading(() => true);
    fetchInProcesOrderPDF({
      orderId: order.OrderId,
      accountId: order.CurrentAccount.AccountId,
    })
      .then(({ response }) => {
        if (response.result.Code !== 200) {
          showToast("Error obteniendo pdf del servidor", true);
        } else {
          var a = document.createElement("A");
          a.href = `data:application/octet-stream;base64,${response.blobfile}`;
          a.download = `${moment(order.OrderInitDate).format("DD-MM-YY")}-${order.OrderId}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setLoading(() => false);
      });
  };

  const onAuthorizeWrapper = () => {
    onAuthorize(authItem);
  };

  const onRejectWrapper = () => {
    onReject(authItem);
  };

  return (
    <tr key={idx} className={style.tableRow}>
      <td className={style.sm}>
        <span className={style.tableTitleMobile}>Fecha</span>
        {moment(authItem.dateTime).format("DD MMM YYYY")}
      </td>
      <td className={`${style.md} ${style.sm}`}>
        <span className={style.tableTitleMobile}>Tipo</span>
        {side}
      </td>
      <td>
        <span className={style.tableTitleMobile}>Instrumento</span>
        {description ? description : "-"}
      </td>
      <td className={`${style.md} ${style.sm}`}>
        <span className={style.tableTitleMobile}>Precio</span>
        {+ammount === 0 ? (
          "-"
        ) : (
          <FormattedNumber
            value={ammount}
            minimumFractionDigits={currency === "GS" ? 0 : 2}
            maximumFractionDigits={currency === "GS" ? 0 : 2}
          />
        )}
      </td>
      <td className={style.sm}>
        <span className={style.tableTitleMobile}>Monto total a operar</span>
        <FormattedNumber
          value={operationValue}
          minimumFractionDigits={currency === "GS" ? 0 : 2}
          maximumFractionDigits={currency === "GS" ? 0 : 2}
        />
      </td>
      <td className={`${style.md} ${style.sm}`}>
        <span className={style.tableTitleMobile}>Moneda</span>
        {currency}
      </td>
      {/* <td>
        <img src={pdf} className={style.icon} alt="pdf-icon" onClick={() => handleDownload(order)} />
      </td> */}
      <td className={style.actionButtons}>
        <GenericButton
          label={"Autorizar"}
          primary
          padding={"10px 10px 10px 6px"}
          backgroundColor={"#27272A"}
          loading={loading}
          width={"130px"}
          handleClick={onAuthorizeWrapper}
          iconSvg={[{ width: "24px", item: acceptAuthIcon }]}
        ></GenericButton>
        <GenericButton
          label={"Rechazar"}
          padding={"10px 10px 10px 6px"}
          backgroundColor={"#E4E4E7"}
          loading={loading}
          width={"130px"}
          textColor={"#27272A"}
          handleClick={onRejectWrapper}
          iconSvg={[{ width: "24px", item: rejectAuthIcon }]}
        ></GenericButton>
      </td>
    </tr>
  );
};

export default AuthorizationRow;
